import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map, share } from 'rxjs/operators';
import { EndPointUrlService } from './end-point-url.service';

@Injectable()
export class ApplicationsService {


  private _selectedApplication: EVA.Core.ApplicationDto;

  private get selectedApplication(): EVA.Core.ApplicationDto {
    return this._selectedApplication || JSON.parse( localStorage.getItem('selectedApplication') );
  }

  private set selectedApplication(newSelectedApplication: EVA.Core.ApplicationDto) {
    this._selectedApplication = newSelectedApplication;

    localStorage.setItem('selectedApplication', JSON.stringify(newSelectedApplication));
  }

  constructor(private http: HttpClient, private $endPointUrlService: EndPointUrlService, private snackbar: MatSnackBar) { }

  fetch() {
    const stream$ = this.http.post<EVA.Core.ListApplicationsResponse>(
      this.$endPointUrlService.endPointUrl + '/message/ListApplications', {}
    ).pipe(
      share(),
      map( applications => applications.Result )
    );

    stream$.subscribe({
      error: () => this.snackbar.open('Failed to fetch applications', null, { duration: 3000 })
    });


    return stream$;
  }

  setSelected( application: EVA.Core.ApplicationDto ) {
    this.selectedApplication = application;
  }

  getSelected(): EVA.Core.ApplicationDto {
    return this.selectedApplication;
  }
}
